import { FileUpload } from './FileUpload';
import { DetailFileUpload } from './DetailFileUpload';
import { DetectedStats } from './DetectedStats';
import { ActionButtons } from './ActionButtons';
import { SaveToLibrary } from './SaveToLibrary';
import { StatusConsole } from './StatusConsole';

export function Sidebar() {
  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="sidebar-brand-mark">
          <span className="sidebar-brand-dot" />
          <span className="sidebar-brand-title">Mark Lumber Profile Studio</span>
        </div>
        <div className="sidebar-brand-subtitle">CNC .C → 3D BAT MODEL</div>
      </div>

      <div className="sidebar-scroll">
        <FileUpload />
        <DetailFileUpload />
        <DetectedStats />
        <ActionButtons />
        <SaveToLibrary />
      </div>

      <div className="sidebar-footer">
        <StatusConsole />
      </div>
    </aside>
  );
}
